import { Base } from '../../../../../common/models';
import {
  DemurrageDetentionStatisticFilterModel,
  ShipmentFiltersDatepickerRangeOutput,
  StatisticFilterModel,
} from './shipment-filters.model';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';
import { ListViewMode } from '../../constants';

export interface ShipmentListSearchCriteria {
  size: number;
  page: number;
  filters: ShipmentFiltersDatepickerRangeOutput;
  shipmentStatisticFilter: StatisticFilterModel;
  viewMode: ListViewMode;
  materialView: boolean;
  id?: number;
  name?: string;
}

export interface DemurrageDetentionSearchCriteria {
  size: number;
  page: number;
  filters: ShipmentFiltersDatepickerRangeOutput;
  dndStatisticFilter: DemurrageDetentionStatisticFilterModel;
  id?: number;
  name?: string;
}

export class ShipmentSearchCriteria implements ShipmentListSearchCriteria, DemurrageDetentionSearchCriteria {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  filters: ShipmentFiltersDatepickerRangeOutput = new ShipmentFiltersDatepickerRangeOutput();
  shipmentStatisticFilter: StatisticFilterModel = new StatisticFilterModel();
  dndStatisticFilter: DemurrageDetentionStatisticFilterModel = new DemurrageDetentionStatisticFilterModel();
  viewMode: ListViewMode | null = null;
  materialView: boolean | null = null;
  id?: number;
  name?: string;

  constructor(params?: ShipmentSearchCriteria | Base) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
